export const DOMEvents = {
  MOUSEDOWN: "mousedown",
  MOUSEUP: "mouseup",
  MOUSEMOVE: "mousemove",
  MOUSELEAVE: "mouseleave",
  TOUCHSTART: "touchstart",
  TOUCHEND: "touchend",
  TOUCHMOVE: "touchmove",
  RESIZE: "resize",
  VISIBILITY_CHANGE: "visibilitychange",
} as const
